<template>
  <div v-if="item" :class="_.container">
    <div :class="[_.title, _._hairlineBottom]">
      <div :class="_.left">
        <img :src="item.merchantPic" />
        <span :class="_._ellipsis">{{ item.merchantName }}</span>
        <div v-if="item.activityName" :class="_.activity">
          {{ item.activityName }}
        </div>
      </div>
      <div v-if="item.status !== 2" :class="_.right">{{ item.statusName }}</div>
      <div v-else :class="[_.right, _.inverse]">
        <template v-if="item.returnAmount">
          差
          <span>{{ item.differCount }}</span>
          人，单件可返
          <span>￥{{ item.returnAmount }}</span>
        </template>
        <template v-else>
          差
          <span>{{ item.differCount }}</span>
          人成团
        </template>
      </div>
    </div>
    <div :class="_.list">
      <div
        v-track="{
          name: '我的订单-条目',
          id: '680fbe95-e978-4e3b-8d40-02875e1dd751',
        }"
        :class="_.item"
        @click="handleClick"
      >
        <div :class="_.left">
          <img :src="item.commodityPic" :class="_.cover" />
          <div :class="_.content">
            <div :class="_.title">
              {{ item.commodityName }}
            </div>
            <div :class="_.desc">{{ item.skuDesc }}</div>
          </div>
        </div>
        <div :class="_.right">
          <div :class="_.price">￥{{ item.unitPrice }}</div>
          <div :class="_.num">x{{ item.quantity }}</div>
        </div>
      </div>
    </div>
    <div :class="_.total">
      <div :class="_.left">
        <template v-if="item.countDownTime">
          距结束
          <span>
            <x-countdown
              :date="item.countDownTime"
              @end="$emit('countdownend')"
            />
          </span>
        </template>
      </div>
      <div v-if="item.status !== 0" :class="_.right">
        <span>{{ `实付 ¥ ${item.orderAmount}` }}</span>
      </div>
      <div v-else :class="_.right">
        共1件商品，
        <span>{{ `合计 ¥ ${item.orderAmount}` }}</span>
      </div>
    </div>
    <OrderActions
      :class="_.actions"
      :item="item"
      @refresh="() => $emit('refresh')"
    />
  </div>
</template>

<script>
  import OrderActions from './order_actions'
  import { navigateTo } from '@/router'

  export default {
    components: {
      OrderActions,
    },

    props: {
      // 条目
      item: {
        type: Object,
        required: true,
      },
    },

    computed: {
      // 订单号
      orderNo() {
        return this.item.orderId
      },
    },

    methods: {
      // 点击订单
      handleClick() {
        this.$emit('click')
        navigateTo(
          this.item.status === 3 ? 'OrderDetail' : 'GroupBuyingOrderDetail',
          {
            orderNo:
              this.item.status === 3 ? this.item.mallOrderNo : this.orderNo,
          },
        )
      },
    },
  }
</script>

<style lang="scss" module>
  .container {
    background: #ffffff;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 12px;
  }

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      flex-grow: 1;
      display: flex;
      align-items: center;
      overflow: hidden;

      img {
        flex-shrink: 0;
        width: 26px;
        height: 26px;
        background: #ffffff;
        border-radius: 50%;
        border: 1px solid #e4e4e4;
        object-fit: cover;
      }

      span {
        font-size: 16px;
        font-weight: var(--bold-value);
        color: #222222;
        padding-left: 12px;
      }

      .activity {
        flex-shrink: 0;
        margin-left: 6px;
        height: 18px;
        border-radius: 9px;
        border: 1px solid #ff202a;
        font-size: 11px;
        color: #ff202a;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 6px;
      }
    }

    .right {
      margin-left: 27px;
      flex-shrink: 0;
      font-size: 14px;
      color: #ff111c;

      &.inverse {
        color: #222222;

        span {
          color: #ff111c;
        }
      }
    }
  }

  .list {
    padding-top: 11px;

    .item {
      display: flex;
      justify-content: space-between;
      padding-top: 12px;

      &:first-child {
        padding-top: 0;
      }

      .left {
        display: flex;

        .cover {
          flex-shrink: 0;
          width: 85px;
          height: 85px;
          border-radius: 8px;
          flex-shrink: 0;
          margin-right: 12px;
          object-fit: cover;
        }

        .content {
          flex-grow: 1;
          display: flex;
          flex-direction: column;

          .title {
            flex-shrink: 0;
            width: 144px;
            font-size: 14px;
            color: #222222;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
          }

          .desc {
            flex-grow: 1;
            font-size: 12px;
            color: #888888;
            padding-top: 4px;
            padding-bottom: 6px;
          }

          .tips {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .tip {
              background: #fff6e9;
              border-radius: 9px;
              font-size: 12px;
              color: #ffa021;
              padding: 3px 6px;
              white-space: nowrap;

              &:not(:first-child) {
                margin-left: 4px;
              }
            }
          }
        }
      }

      .right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .price {
          flex-shrink: 0;
          font-size: 14px;
          color: #222222;
        }

        .num {
          flex-grow: 1;
          font-size: 12px;
          color: #888888;
          padding-top: 4px;
        }

        .status {
          flex-shrink: 0;
          background: #fff3f2;
          border-radius: 1000px;
          font-size: 12px;
          color: #ff313a;
          padding: 2px 7px;
          white-space: nowrap;
        }
      }
    }
  }

  .total {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      flex-grow: 1;
      font-size: 14px;
      color: #222222;

      span {
        color: #ff202a;
      }
    }

    .right {
      flex-shrink: 0;
      text-align: right;
      font-size: 14px;
      color: #aaaaaa;

      span {
        color: #ff202a;
      }
    }
  }

  .actions {
    margin-top: 12px;
  }
</style>
